import { create } from "zustand";
import {
  FORTUNE_WHEEL_STEPS,
  FortuneWheelListResponse,
  FortuneWheelSectionItem,
} from "../type/FortuneWheel";

type StoreState = {
  sectionList: FortuneWheelSectionItem[];
  prizeSection: Nullable<FortuneWheelSectionItem>;
  isAvailable: boolean;
  nextAvailableAt: string;
  error: string;
  step: FORTUNE_WHEEL_STEPS;
  spinRequestedAt: number | null;
};

type Actions = {
  setSectionList: (payload: FortuneWheelListResponse) => void;
  setSection: (payload: FortuneWheelSectionItem | null) => void;
  setNextAvailable: (payload: string) => void;
  setAvailable: (payload: boolean) => void;
  setError: (payload: string) => void;
  setStep: (step: FORTUNE_WHEEL_STEPS) => void;
  requestSpin: () => void;
  clearSpinRequest: () => void;
  clear: () => void;
};

const initialState: StoreState = {
  sectionList: [],
  prizeSection: null,
  isAvailable: false,
  nextAvailableAt: "",
  step: FORTUNE_WHEEL_STEPS.INIT,
  error: "",
  spinRequestedAt: null,
};

export const useFortuneWheelStore = create<StoreState & Actions>((set) => ({
  ...initialState,

  setSectionList: (payload) =>
    set((state) => ({
      ...state,
      sectionList: payload.sections,
    })),

  setSection: (payload) =>
    set((state) => ({
      ...state,
      prizeSection: payload,
    })),

  setNextAvailable: (payload) =>
    set((state) => ({
      ...state,
      nextAvailableAt: payload,
    })),

  setAvailable: (payload) =>
    set((state) => ({
      ...state,
      isAvailable: payload,
    })),

  setError: (payload) =>
    set((state) => ({
      ...state,
      error: payload,
    })),

  requestSpin: () =>
    set((state) => ({
      ...state,
      spinRequestedAt: Date.now(),
    })),

  setStep: (step) =>
    set((state) => ({
      ...state,
      step,
    })),

  clearSpinRequest: () =>
    set((state) => ({
      ...state,
      spinRequestedAt: null,
    })),

  clear: () => set(() => ({ ...initialState })),
}));
